import { type LocationContent } from "@/components/location-page";
import { FEES, FIRM } from "@/lib/firm";

export const CONTENT: LocationContent = {
  slug: "baringa",
  name: "Baringa",
  title: "Baringa and Aura conveyancing lawyers",
  metaTitle: `Baringa & Aura Conveyancing Lawyers | ${FIRM.name}`,
  description: `Fixed-fee conveyancing for Baringa, Aura and Nirimba — house and land, off-the-plan and new builds. Sales ${FEES.sale} incl. GST, purchases ${FEES.purchase}. Call ${FIRM.phone}.`,
  lead: "Baringa and the wider Aura estate are new-build country: land contracts, building contracts, sunset dates and estate covenants. These are the contracts most often signed without advice — and most often regretted.",
  paragraphs: [
    "We act for Baringa, Nirimba and Aura buyers from our office at Golden Beach. Almost every matter here involves a developer's or builder's contract drafted to protect the other side, not you.",
    "A house and land package is two separate agreements. The land contract usually settles on registration of the plan, with a sunset date that lets the developer walk away. The build contract then carries its own progress payments, variation rights and delay provisions.",
    "We review both before you sign, explain what you are actually committing to, and act on the land settlement at a fixed fee.",
  ],
  localNotes: [
    {
      t: "Sunset dates and plan registration",
      d: "Registration timing drives your settlement date and your finance approval validity. We track the sunset date and tell you what happens if the plan is late.",
    },
    {
      t: "Estate covenants and design guidelines",
      d: "Aura covenants control facade, materials, fencing, landscaping and build start deadlines. Breaching one can cost more than the feature you wanted.",
    },
    {
      t: "Building contract review",
      d: "Progress payment stages, provisional and prime cost sums, variation pricing and extension of time clauses. This is where new-build budgets blow out.",
    },
    {
      t: "Finance validity on long settlements",
      d: "Approvals commonly lapse before registration. We flag the re-approval timing early so your finance does not expire the week before settlement.",
    },
  ],
  suburbs: ["Nirimba", "Aura", "Caloundra West", "Bells Creek", "Pelican Waters", "Little Mountain"],
  faqs: [
    {
      q: "What is a sunset date and why does it matter in Aura?",
      a: "A sunset date is the long-stop date by which the plan of subdivision must be registered. If it is not, either party — usually in practice the developer — can terminate. In a rising market that can mean losing the lot and re-buying at today's price, so the clause deserves a careful read before signing.",
    },
    {
      q: "Do you review builder's contracts as well as the land contract?",
      a: "Yes. We review the building contract alongside the land conveyance so you understand progress payments, allowances, variation pricing and delay rights, and how the two contracts interact if one is delayed.",
    },
    {
      q: "Is there a cooling-off period on an off-the-plan contract?",
      a: "A standard Queensland residential contract carries a five business day cooling-off period, but a termination during it costs 0.25% of the price and the disclosure regime for off-the-plan lots adds separate rights. Advice before signing is far better protection than relying on cooling off.",
    },
  ],
};
